import React from 'react'
import { TextLabelWrapper } from '../../assets/styles/FilterStyle'

function TextLabel({title="",value=""}) {
  return (
    <TextLabelWrapper>
        <h5>{title || "-"}</h5>
        <p>{value || '-'}</p>
    </TextLabelWrapper>
  )
}

export default TextLabel